import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAppointmentTypesForBookingQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAppointmentTypesForBookingQuery = {
  __typename?: "Query";
  getAppointmentTypes: Array<{
    __typename?: "AppointmentType";
    uuid: string;
    name: string;
    color: string;
    duration: number;
    staff: Array<{
      __typename?: "Staff";
      userUuid: string;
      firstName: string | null;
      lastName: string | null;
    } | null>;
  }>;
};

export type AppointmentTypeOptionFragment = {
  __typename?: "AppointmentType";
  uuid: string;
  name: string;
  color: string;
  duration: number;
  staff: Array<{
    __typename?: "Staff";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
  } | null>;
};

export type GetUserCreditsQueryVariables = Types.Exact<{
  input: Types.GetUserAppointmentCreditsCountByTypeInput;
}>;

export type GetUserCreditsQuery = {
  __typename?: "Query";
  getUserAppointmentCreditsCountByType: {
    __typename?: "AppointmentCreditCount";
    count: number;
  };
};

export type BookAppointmentMutationVariables = Types.Exact<{
  input: Types.StaffBookAppointmentInput;
}>;

export type BookAppointmentMutation = {
  __typename?: "Mutation";
  staffBookAppointment: {
    __typename?: "StaffBookAppointmentResponse";
    successfulBookings: Array<{
      __typename?: "AppointmentSchedule";
      uuid: string;
    }>;
    failedBookings: Array<{
      __typename?: "TimeRange";
      startTime: string;
      endTime: string;
    }>;
  };
};

export type CreateAppointmentTemplateMutationVariables = Types.Exact<{
  input: Types.CreateAppointmentTemplateInput;
}>;

export type CreateAppointmentTemplateMutation = {
  __typename?: "Mutation";
  createAppointmentTemplate: {
    __typename?: "AppointmentTemplateResponse";
    data: Array<{ __typename?: "AppointmentTemplate"; uuid: string }>;
  };
};

export const AppointmentTypeOptionFragmentDoc = gql`
  fragment AppointmentTypeOption on AppointmentType {
    uuid
    name
    color
    duration
    staff {
      userUuid
      firstName
      lastName
    }
  }
`;
export const GetAppointmentTypesForBookingDocument = gql`
  query GetAppointmentTypesForBooking {
    getAppointmentTypes {
      ...AppointmentTypeOption
    }
  }
  ${AppointmentTypeOptionFragmentDoc}
`;

/**
 * __useGetAppointmentTypesForBookingQuery__
 *
 * To run a query within a React component, call `useGetAppointmentTypesForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentTypesForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentTypesForBookingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppointmentTypesForBookingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAppointmentTypesForBookingQuery,
    GetAppointmentTypesForBookingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppointmentTypesForBookingQuery,
    GetAppointmentTypesForBookingQueryVariables
  >(GetAppointmentTypesForBookingDocument, options);
}
export function useGetAppointmentTypesForBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentTypesForBookingQuery,
    GetAppointmentTypesForBookingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentTypesForBookingQuery,
    GetAppointmentTypesForBookingQueryVariables
  >(GetAppointmentTypesForBookingDocument, options);
}
export type GetAppointmentTypesForBookingQueryHookResult = ReturnType<
  typeof useGetAppointmentTypesForBookingQuery
>;
export type GetAppointmentTypesForBookingLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentTypesForBookingLazyQuery
>;
export type GetAppointmentTypesForBookingQueryResult = Apollo.QueryResult<
  GetAppointmentTypesForBookingQuery,
  GetAppointmentTypesForBookingQueryVariables
>;
export const GetUserCreditsDocument = gql`
  query GetUserCredits($input: GetUserAppointmentCreditsCountByTypeInput!) {
    getUserAppointmentCreditsCountByType(input: $input) {
      count
    }
  }
`;

/**
 * __useGetUserCreditsQuery__
 *
 * To run a query within a React component, call `useGetUserCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreditsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserCreditsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserCreditsQuery,
    GetUserCreditsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserCreditsQuery, GetUserCreditsQueryVariables>(
    GetUserCreditsDocument,
    options,
  );
}
export function useGetUserCreditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserCreditsQuery,
    GetUserCreditsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserCreditsQuery, GetUserCreditsQueryVariables>(
    GetUserCreditsDocument,
    options,
  );
}
export type GetUserCreditsQueryHookResult = ReturnType<
  typeof useGetUserCreditsQuery
>;
export type GetUserCreditsLazyQueryHookResult = ReturnType<
  typeof useGetUserCreditsLazyQuery
>;
export type GetUserCreditsQueryResult = Apollo.QueryResult<
  GetUserCreditsQuery,
  GetUserCreditsQueryVariables
>;
export const BookAppointmentDocument = gql`
  mutation BookAppointment($input: StaffBookAppointmentInput!) {
    staffBookAppointment(input: $input) {
      successfulBookings {
        uuid
      }
      failedBookings {
        startTime
        endTime
      }
    }
  }
`;
export type BookAppointmentMutationFn = Apollo.MutationFunction<
  BookAppointmentMutation,
  BookAppointmentMutationVariables
>;

/**
 * __useBookAppointmentMutation__
 *
 * To run a mutation, you first call `useBookAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookAppointmentMutation, { data, loading, error }] = useBookAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookAppointmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookAppointmentMutation,
    BookAppointmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookAppointmentMutation,
    BookAppointmentMutationVariables
  >(BookAppointmentDocument, options);
}
export type BookAppointmentMutationHookResult = ReturnType<
  typeof useBookAppointmentMutation
>;
export type BookAppointmentMutationResult =
  Apollo.MutationResult<BookAppointmentMutation>;
export type BookAppointmentMutationOptions = Apollo.BaseMutationOptions<
  BookAppointmentMutation,
  BookAppointmentMutationVariables
>;
export const CreateAppointmentTemplateDocument = gql`
  mutation CreateAppointmentTemplate($input: CreateAppointmentTemplateInput!) {
    createAppointmentTemplate(input: $input) {
      data {
        uuid
      }
    }
  }
`;
export type CreateAppointmentTemplateMutationFn = Apollo.MutationFunction<
  CreateAppointmentTemplateMutation,
  CreateAppointmentTemplateMutationVariables
>;

/**
 * __useCreateAppointmentTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentTemplateMutation, { data, loading, error }] = useCreateAppointmentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAppointmentTemplateMutation,
    CreateAppointmentTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAppointmentTemplateMutation,
    CreateAppointmentTemplateMutationVariables
  >(CreateAppointmentTemplateDocument, options);
}
export type CreateAppointmentTemplateMutationHookResult = ReturnType<
  typeof useCreateAppointmentTemplateMutation
>;
export type CreateAppointmentTemplateMutationResult =
  Apollo.MutationResult<CreateAppointmentTemplateMutation>;
export type CreateAppointmentTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAppointmentTemplateMutation,
    CreateAppointmentTemplateMutationVariables
  >;
